import { render, staticRenderFns } from "./statistic_pie2.vue?vue&type=template&id=19f371f5&"
import script from "./statistic_pie2.vue?vue&type=script&lang=js&"
export * from "./statistic_pie2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports